import { useQuery } from "@tanstack/react-query";

import LogService from "@/api/services/logs";

export function useImportLogs(pageSize: number) {
  return useQuery({
    queryKey: ["logs", "import", pageSize],
    queryFn: () => LogService.getImportLogs(pageSize),
  });
}
